import * as departrment from "./departrment";
import * as supplier from "./supplier";
export default [departrment,supplier]



// WEBPACK FOOTER //
// ./src/store/modules/account-management/index.js